module.exports = __webpack_public_path__ + "img/pr-8.a4bad1d3.png";